import { ADJUSTVALUE_STAD, CONN_VALUE_R } from "../../constants/adjustmentsOptions";
import { AdjustmentDefault } from "../../constants/defaultValues/adjustmentDefault";
import { ACTUATORS_KEY, ADJUSTVALUE_KEY, CABINET_KEY, CONNECTED_DIFF_KEY, CONNECTED_TEMP_KEY, CONNECTION_DESIGN_KEY, CONNECTION_VALUE_KEY, CUTOFF_KEY, DRIPPLATE_KEY, ENERGYMEASUREMENT_KEY, INSULATION_KEY, MANOMETER_KEY, MATERIAL_KEY, MIXINGVESSELS_KEY, STAND_KEY, THERMO_KEY } from "../../constants/keys/adjustParamsKeys";
import { PRODUCTFAMILY_PR, PRODUCTFAMILY_SR, PRODUCTLINE_FLEX, PRODUCTLINE_GREEN, PRODUCTLINE_SMART } from "../../constants/productlineConstants";
import { ADJUST_VALVE_STADF } from "../../constants/shuntOptions";
import { AdjustmentsEnum, CalcParamsEnum, DriftParamEnum, ProductLineEnum, SessionParamsEnum, ShuntParamsEnum } from "../../enums";

export const getDefaultAdjustData = (sessionParams, productLineParams, shuntParams, calcParams, driftParams) => {
    const prodFamily = ProductLineEnum.ProductFamily.getContextValue(productLineParams);
    const prodLine = ProductLineEnum.ProductLine.getContextValue(productLineParams);
    const greenLevel = Number(ProductLineEnum.ProductGreenLevel.getContextValue(productLineParams));

    let defaultValues = {};

    if (prodFamily === PRODUCTFAMILY_SR) {
        if (prodLine === PRODUCTLINE_FLEX) {
            defaultValues = AdjustmentDefault.SRFlexDefault;
        }
        else if (prodLine === PRODUCTLINE_GREEN) {
            defaultValues = AdjustmentDefault.SRGreenDefault;
        }
        else if (prodLine === PRODUCTLINE_SMART) {
            //console.log("Here?")
            defaultValues = AdjustmentDefault.SRSmartDefault;
        }
        else {
            defaultValues = AdjustmentDefault.SRDefault;
        }
    }
    else if (prodFamily === PRODUCTFAMILY_PR) {
        if (prodLine === PRODUCTLINE_GREEN) {
            defaultValues = AdjustmentDefault.PRGreenDefault;
        }
        else {
            defaultValues = AdjustmentDefault.PRDefault;
        }
    }
    else {
        if (prodLine === PRODUCTLINE_GREEN) {
            defaultValues = AdjustmentDefault.VAGreenDefault;
        }
        else {
            defaultValues = AdjustmentDefault.VADefault;
        }
    }

    const minTemp = getMinTempValue(driftParams);
    if (minTemp <= 2) {
        if (prodLine === PRODUCTLINE_GREEN) {
            if (greenLevel === 2) {
                defaultValues = { ...defaultValues, ...AdjustmentDefault.IsolationGreenII_Below2Degrees }
            }
            else {
                defaultValues = { ...defaultValues, ...AdjustmentDefault.IsolationGreen_Below2Degrees }
            }

        }
        else {
            defaultValues = { ...defaultValues, ...AdjustmentDefault.Isolation_Below2Degrees }
        }
    }
    else if (minTemp < 18) {
        if (prodLine === PRODUCTLINE_GREEN) {
            if (greenLevel === 2) {
                defaultValues = { ...defaultValues, ...AdjustmentDefault.IsolationGreenII_Below18Degrees }
            }
            else {
                defaultValues = { ...defaultValues, ...AdjustmentDefault.IsolationGreen_Below18Degrees }
            }

        }
        else {
            defaultValues = { ...defaultValues, ...AdjustmentDefault.Isolation_Below18Degrees }
        }
    }

    if (prodLine !== PRODUCTLINE_GREEN && ShuntParamsEnum.AdjustmentValve.getContextValue(shuntParams) === ADJUST_VALVE_STADF && CalcParamsEnum.SekDimRow.getContextValue(calcParams) != null && CalcParamsEnum.SekDimRow.getContextValue(calcParams).dim <= 50) {
        defaultValues = { ...defaultValues, adjustValue: ADJUSTVALUE_STAD }
    }

    if (SessionParamsEnum.IsApiSession.getContextValue(sessionParams) === true) {
        defaultValues['connectionValue'] = CONN_VALUE_R;
    }

    return defaultValues;
}

export const getCurrentAdjustData = (adjustParams) => {
    let data = {};

    if (AdjustmentsEnum.ConnectionDesign.getContextValue(adjustParams) != null && AdjustmentsEnum.ConnectionDesign.getContextValue(adjustParams) !== ""){
        data[CONNECTION_DESIGN_KEY] = AdjustmentsEnum.ConnectionDesign.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.ConnectionValue.getContextValue(adjustParams) != null && AdjustmentsEnum.ConnectionValue.getContextValue(adjustParams) !== ""){
        data[CONNECTION_VALUE_KEY] = AdjustmentsEnum.ConnectionValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.MaterialValue.getContextValue(adjustParams) != null && AdjustmentsEnum.MaterialValue.getContextValue(adjustParams) !== ""){
        data[MATERIAL_KEY] = AdjustmentsEnum.MaterialValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.ThermoValue.getContextValue(adjustParams) != null && AdjustmentsEnum.ThermoValue.getContextValue(adjustParams) !== ""){
        data[THERMO_KEY] = AdjustmentsEnum.ThermoValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.IsolationValue.getContextValue(adjustParams) != null && AdjustmentsEnum.IsolationValue.getContextValue(adjustParams) !== ""){
        data[INSULATION_KEY] = AdjustmentsEnum.IsolationValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.CutOffValue.getContextValue(adjustParams) != null && AdjustmentsEnum.CutOffValue.getContextValue(adjustParams) !== ""){
        data[CUTOFF_KEY] = AdjustmentsEnum.CutOffValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.ManometerValue.getContextValue(adjustParams) != null && AdjustmentsEnum.ManometerValue.getContextValue(adjustParams) !== ""){
        data[MANOMETER_KEY] = AdjustmentsEnum.ManometerValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.StandValue.getContextValue(adjustParams) != null && AdjustmentsEnum.StandValue.getContextValue(adjustParams) !== ""){
        data[STAND_KEY] = AdjustmentsEnum.StandValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.CabinetValue.getContextValue(adjustParams) != null && AdjustmentsEnum.CabinetValue.getContextValue(adjustParams) !== ""){
        data[CABINET_KEY] = AdjustmentsEnum.CabinetValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.ActuatorsValue.getContextValue(adjustParams) != null && AdjustmentsEnum.ActuatorsValue.getContextValue(adjustParams) !== ""){
        data[ACTUATORS_KEY] = AdjustmentsEnum.ActuatorsValue.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.DripPlateValue.getContextValue(adjustParams) != null && AdjustmentsEnum.DripPlateValue.getContextValue(adjustParams) !== ""){
        data[DRIPPLATE_KEY] = AdjustmentsEnum.DripPlateValue.getContextValue(adjustParams);
    }
    
    if (AdjustmentsEnum.AdjustValue.getContextValue(adjustParams) != null && AdjustmentsEnum.AdjustValue.getContextValue(adjustParams) !== ""){
        data[ADJUSTVALUE_KEY] = AdjustmentsEnum.AdjustValue.getContextValue(adjustParams);
    }
    
    if (AdjustmentsEnum.MixingVessels.getContextValue(adjustParams) != null && AdjustmentsEnum.MixingVessels.getContextValue(adjustParams) !== ""){
        data[MIXINGVESSELS_KEY] = AdjustmentsEnum.MixingVessels.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.EnergyMeasurement.getContextValue(adjustParams) != null && AdjustmentsEnum.EnergyMeasurement.getContextValue(adjustParams) !== ""){
        data[ENERGYMEASUREMENT_KEY] = AdjustmentsEnum.EnergyMeasurement.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.ConnectedTemp.getContextValue(adjustParams) != null && AdjustmentsEnum.ConnectedTemp.getContextValue(adjustParams) !== ""){
        data[CONNECTED_TEMP_KEY] = AdjustmentsEnum.ConnectedTemp.getContextValue(adjustParams);
    }

    if (AdjustmentsEnum.ConnectedDiff.getContextValue(adjustParams) != null && AdjustmentsEnum.ConnectedDiff.getContextValue(adjustParams) !== ""){
        data[CONNECTED_DIFF_KEY] = AdjustmentsEnum.ConnectedDiff.getContextValue(adjustParams);
    }

    return data;
}

export const hasChangedDefaultValues = (sessionParams, productLineParams, shuntParams, calcParams, adjustParams, driftParams) => {
    let savedData = getCurrentAdjustData(adjustParams);
    let changed = false;

    if (savedData != null && Object.keys(savedData).length > 0){
        let orgData = getDefaultAdjustData(sessionParams, productLineParams, shuntParams, calcParams, driftParams);

        if (Object.keys(orgData).length === Object.keys(savedData).length){
            Object.keys(savedData).forEach((key) => {
                if (orgData[key] !== savedData[key]){
                    changed = true;
                }
            });
        }
        else{
            changed = true;
        }
    }
    console.log("Has Changed? ", changed)
    return changed;
}

const getMinTempValue = (driftParams) => {
    let primTempIn = Number(DriftParamEnum.PrimTempIn.getContextValue(driftParams));
    let primTempOut = Number(DriftParamEnum.PrimTempOut.getContextValue(driftParams));
    let secTempIn = Number(DriftParamEnum.SecTempIn.getContextValue(driftParams));
    let secTempOut = Number(DriftParamEnum.SecTempOut.getContextValue(driftParams));

    //console.log("Vals:", primTempIn, primTempOut, secTempIn, secTempOut)
    if (isNaN(primTempIn) || DriftParamEnum.PrimTempIn.getContextValue(driftParams) == null) {
        primTempIn = Number.MAX_SAFE_INTEGER;
    }
    if (isNaN(primTempOut) || DriftParamEnum.PrimTempOut.getContextValue(driftParams) == null) {
        primTempOut = Number.MAX_SAFE_INTEGER;
    }
    if (isNaN(secTempIn) || DriftParamEnum.SecTempIn.getContextValue(driftParams) == null) {
        secTempIn = Number.MAX_SAFE_INTEGER;
    }
    if (isNaN(secTempOut) || DriftParamEnum.SecTempOut.getContextValue(driftParams) == null) {
        secTempOut = Number.MAX_SAFE_INTEGER;
    }

    return Math.min(primTempIn, primTempOut, secTempIn, secTempOut);
}
